import { PrepareScreen as DLPrepareScreen, ExecuteSpin as DLExecuteSpin, ToggleQROverlay as DLToggleQROverlay, ToggleThanksOverlay as DLToggleThanksOverlay, EnterMachineView as DLEnterMachineView, SaveConfig as DLSaveConfig, GetConfig as DLGetConfig, GetScreens as DLGetScreens, CreateScreen as DLCreateScreen, DeleteScreen as DLDeleteScreen, IdentifyScreens as DLIdentifyScreens } from './../DL/SlotMachine'


/**
 * LÓGICA DE NEGOCIO (BL): SLOT MACHINE
 */

const PrepareMachine = async (screenId) => {
    try {
        if (!screenId || screenId <= 0) {
            return { success: false, message: 'El ID de la pantalla es inválido.' };
        }

        const response = await DLPrepareScreen(screenId);
        
        if (response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.message };
        }
    } catch (error) {
        return { success: false, message: 'Excepción en BL al preparar la máquina.' };
    }
};

// const SpinMachine = async (formData) => {
//     try {
//         // 1. Sanitización y Parseo
//         // const prob = parseFloat(formData.winProbability);
//         // const baseMs = parseInt(formData.baseTimeMs, 10);
//         // const celebMs = parseInt(formData.celebrationTimeMs, 10);
//         // // const screenId = parseInt(formData.screenId, 10);
//         const targetScreenId = parseInt(formData.targetScreenId, 10);

//         // 2. Validaciones de Negocio
//         // if (isNaN(prob) || prob < 0 || prob > 100) {
//         //     return { success: false, message: 'La probabilidad debe ser un valor entre 0 y 100.' };
//         // }
        
//         // if (isNaN(baseMs) || baseMs < 1000) {
//         //     return { success: false, message: 'El tiempo base de giro debe ser mínimo 1000ms.' };
//         // }

//         // if (!formData.symbols || formData.symbols.length < 3) {
//         //     return { success: false, message: 'Debes configurar al menos 3 símbolos.' };
//         // }

//         // 3. Ejecución al DL (Convertimos probabilidad de 0-100 a decimal 0.0-1.0 para el Backend)
//         const payload = {
//             targetScreenId: targetScreenId,
//             //screenId: screenId,
//             //winProbability: prob / 100, 
//             //baseTimeMs: baseMs,
//             //celebrationTimeMs: celebMs,
//             //symbols: formData.symbols
//         };

//         const response = await DLExecuteSpin(payload);

//         // 4. Retorno de resultado
//         if (response.success) {
//             return { success: true, data: response.data };
//         } else {
//             return { success: false, message: response.message };
//         }

//     } catch (error) {
//         return { success: false, message: 'No ha sido posible ejecutar el juego. Inténtalo nuevamente.' };
//     }
// };

const SpinMachine = async (formData) => {
    try {
        // 1. Sanitización y Parseo
        // Solo necesitamos saber a qué pantalla va dirigido y, opcionalmente, quién tira.
        const targetScreenId = parseInt(formData.targetScreenId, 10) || 0;
        
        // Si el tiro viene del celular, traerá playerName. Si viene del Admin, dirá "Administrador".
        const playerName = formData.playerName || "Administrador"; 
        const playerContact = formData.playerContact || "";

        // 2. Construcción del Payload
        // Ya no mandamos probabilidades ni tiempos, de eso se encarga el C# en el servidor.
        const payload = {
            targetScreenId: targetScreenId,
            playerName: playerName,
            playerContact: playerContact
        };

        // 3. Ejecución al DL
        const response = await DLExecuteSpin(payload);

        // 4. Retorno de resultado
        if (response.success) {
            return { success: true, data: response.data || response };
        } else {
            return { success: false, message: response.message || 'Error al ejecutar el giro.' };
        }

    } catch (error) {
        console.error("[BL SpinMachine] Error:", error);
        return { success: false, message: 'No ha sido posible ejecutar el juego. Inténtalo nuevamente.' };
    }
};

const ToggleQR = async (targetScreenId, isVisible) => {
    return await DLToggleQROverlay(parseInt(targetScreenId, 10), isVisible);
};

const ToggleThanks = async (targetScreenId, isVisible) => {
    return await DLToggleThanksOverlay(parseInt(targetScreenId, 10), isVisible);
};

const EnterMachine = async () => {
    return await DLEnterMachineView();
};

const SaveMachineConfig = async (config) => {
    // Aquí hacemos la conversión de probabilidad (De 30 a 0.3) para que la BD sea feliz
    const dbConfig = {
        ...config,
        winProbability: config.winProbability / 100
    };
    return await DLSaveConfig(dbConfig);
};

const GetMachineConfig = async (targetScreenId) => {
    const result = await DLGetConfig(targetScreenId);
    if (result.success && result.data) {
        // Regresamos la probabilidad a formato humano (De 0.3 a 30)
        result.data.winProbability = Math.round(result.data.winProbability * 100);
    }
    return result;
};

const GetActiveScreens = async () => {
    return await DLGetScreens();
};

const CreateMachineScreen = async (name) => {
    return await DLCreateScreen(name);
};

const DeleteMachineScreen = async (screenId) => {
    return await DLDeleteScreen(screenId);
};

const IdentifyAllScreens = async () => {
    return await DLIdentifyScreens();
};

export { PrepareMachine, SpinMachine, ToggleQR, ToggleThanks, EnterMachine, SaveMachineConfig, GetMachineConfig, GetActiveScreens, CreateMachineScreen, DeleteMachineScreen, IdentifyAllScreens };